module.exports = __webpack_public_path__ + "static/Verne1-2891a7857963e9298816206dfd0e605d.webp";